// A font size for an inline style: the design size in px, plus the app-wide
// bump, never below the minimum.
//
// The same rule as the type scale in styles/tokens.css and the `text-fs-<px>`
// utility in globals.css — it reads their CSS variables rather than restating
// the numbers, so the two knobs (`--font-bump`, `--font-min`) stay in one place.
// For SVG text (chart ticks) pass it through `style`, not the `fontSize`
// attribute: presentation attributes do not take CSS functions.
export function fontPx(px: number): string {
  return `max(var(--font-min), calc(${px}px + var(--font-bump)))`;
}
